export default __webpack_public_path__ + "static/media/background-right.35cfc1bd.png";